/* eslint-disable react-hooks/exhaustive-deps */
import { Spin } from 'antd';
import SelectWithPagination from 'components/shared/dropdown-with-pagination/SelectWithPagination';
import { useCallback, useEffect, useState } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, Popover } from 'antd';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  COPAY_ANALYTICS_APP_ID,
  COPAY_ANALYTICS_FILTER_NAME,
  COPAY_CONSTANT,
  TABLE_NAME_COPAY_ANALYTICS,
  FLAG,
  PAGINATION,
  INSIGHT_TYPE,
  NUMBER_ZERO,
  COPAY_ANALYTICS_COLUMNS,
  BOOLEAN_TRUE,
  NUMBER_ONE,
  SORT_BY,
  ColumnVisiblity,
  MODULE_NAME,
  QUERY_KEY,
  ACCOUNT_TYPE,
  COMPONENT_MAPPING,
} from 'constants/constants';
import {
  exportData,
  getCopayAnalyticsData,
} from 'store/customer/customer-view-actions';

import {
  setInsightType,
  setSelectedCustomer,
  setSeletedView,
  setFilterInit,
  setSelectedInsightView,
  setAllInsightView,
  setCopayAnalyticsFiltersInitialState,
} from 'store/customer/customerViewSlice';
import { getCustomerExpr, getRestrictedColumn, isArray } from 'utils/utils';
import styles from './../../shared/table/ConfigurableTable.module.scss';
import classes from './CopayAnalytics.module.scss';
import { useNavigate } from 'react-router-dom';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';
import { uniq } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import ConfigProviderCheckbox from 'components/shared/checkbox/CheckboxConfigProvider';

const CopayAnalytics = () => {
  const [menuIsOpen, setMenuIsOpen] = useState({
    copayEcosystem: false,
    copaySiteAddressName: false,
    copaySquad: false,
    copayQuarter: false,
    copayProduct: false,
  });
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [copayExpressions, setCopayExpressions] = useState();
  const measure = COPAY_CONSTANT.VIEW_MEASURE;

  const navigation = useNavigate();
  const timeSpanOptions = useSelector(
    (state) => state?.CustomerView?.timespans
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );

  const selectedSite = useSelector(
    (state) =>
      state?.CustomerView?.copayAnalyticsFilters?.copaySiteAddressName
        ?.selectedValue
  );

  const selectedTimePeriod = useSelector(
    (state) =>
      state?.CustomerView?.copayAnalyticsFilters?.copayQuarter?.selectedValue
  );

  const selectedProduct = useSelector(
    (state) =>
      state?.CustomerView?.copayAnalyticsFilters?.copayProduct?.selectedValue
  );
  const selectedEcosystem = useSelector(
    (state) =>
      state?.CustomerView?.copayAnalyticsFilters?.copayEcosystem?.selectedValue
  );
  const selectedSquad = useSelector(
    (state) =>
      state?.CustomerView?.copayAnalyticsFilters?.copaySquad?.selectedValue
  );

  const isExporting = useSelector(
    (state) => state?.CustomerView?.exportCopayAnalytics
  );
  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );

  const dispatch = useDispatch();

  const [copayDimenssion, setCopayDimension] = useState(['Product']);

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const activeSectionTab = useSelector(
    (state) => state?.CustomerView?.activeSectionTab
  );

  const defaultSelectedColumns = COPAY_ANALYTICS_COLUMNS.reduce(
    (result, column) => {
      if (
        column.isMandatory === 'Y' &&
        column.dataIndex &&
        column.columnVisiblity !== ColumnVisiblity.Optional
      ) {
        result.push(column.dataIndex);
      }
      return result;
    },
    []
  );
  const [selectedColumns, setSelectedColumns] = useState(
    defaultSelectedColumns
  );

  const filteredColumns = COPAY_ANALYTICS_COLUMNS.filter((column) =>
    selectedColumns.includes(column.dataIndex)
  );

  const timePeriodOptions = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters?.TimePeriod
  );
  const siteOptions = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters?.SiteName
  );
  const productOptions = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters?.Product
  );
  const squadOptions = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters?.Squad
  );
  let copayFilterExpression;

  // Pagination and Sorting
  const defaultSorting = {
    column: 'Total Paid Claims',
    order: SORT_BY.descend,
  };
  const defaultPageSize = PAGINATION.defaultPageSize;
  const initailState = {
    values: [],
    offset: NUMBER_ZERO, // Required to send 0 value to backed api
    totalSize: NUMBER_ZERO,
  };

  const [copayData, setCopayData] = useState(initailState);
  const [pageIndex, setPageIndex] = useState(NUMBER_ONE); // Required to send 1 value to data table
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: defaultSorting.column,
    order: defaultSorting.order,
  });

  const pagination = {
    current: pageIndex,
    total: copayData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  // React Query to fetch PayerMix Data
  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEY.CopayAnalyticsTable,
      copayAnalyticsFilters,
      copayDimenssion,
      selectedCustomer?.value,
      sortBy.column,
      sortBy.order,
      pageIndex,
      pageSize,
    ],
    queryFn: async () => {
      const result = await getCopayData();
      return result?.values?.length > 0 ? result : initailState;
    },
    enabled:
      activeSectionTab === COMPONENT_MAPPING.CopayAnalytics ? true : false,
  });

  // Update local state when query data changes
  useEffect(() => {
    if (data) {
      setCopayData(data);
    }
  }, [data]);

  const buildExpression = () => {
    const accountExp = getCustomerExpr(
      selectedCustomer,
      isArray(selectedCustomer)
    );
    const isAllSite =
      isArray(siteOptions) && siteOptions?.length === selectedSite?.length;

    const isAllProduct =
      isArray(productOptions) &&
      productOptions?.length === selectedProduct?.length;

    const isAllTimePeriod =
      isArray(timePeriodOptions) &&
      timePeriodOptions?.length === selectedTimePeriod?.length;

    const isAllSquad =
      isArray(squadOptions) && squadOptions?.length === selectedSquad?.length;

    const timeperiod = isAllTimePeriod ? 'TimePeriod=' : selectedTimePeriod;
    const squad = isAllSquad ? 'Squad=' : selectedSquad;
    const site = isAllSite ? 'Site=' : selectedSite;
    const product = isAllProduct ? 'Product=' : selectedProduct;

    // build ecosystem expression
    const ecosystemExp = isArray(selectedEcosystem)
      ? 'Ecosystem={"' +
        selectedEcosystem.map((a) => a?.label).join('","') +
        '"}'
      : selectedEcosystem?.label
        ? 'Ecosystem={"' + selectedEcosystem?.label + '"}'
        : '';

    // build timeperiod expression
    const timeperiodExp = isArray(timeperiod)
      ? 'Quarter={"' + timeperiod.map((a) => a?.label).join('","') + '"}'
      : '';
    // build squad expression
    const squadExp = isArray(squad)
      ? 'Squad={"' + squad.map((a) => a?.label).join('","') + '"}'
      : '';

    const siteExp = isArray(site)
      ? 'Site_ID={"' + site.map((a) => a?.value).join('","') + '"}'
      : '';
    // build product expression
    const productExp = isArray(product)
      ? 'Product={"' + product.map((a) => a?.label).join('","') + '"}'
      : '';
    let copayFilterExpression = `${accountExp}`;
    if (ecosystemExp !== '') {
      copayFilterExpression = copayFilterExpression.concat(`, ${ecosystemExp}`);
    }
    if (timeperiodExp !== '') {
      copayFilterExpression = copayFilterExpression.concat(
        `, ${timeperiodExp}`
      );
    }
    if (squadExp !== '') {
      copayFilterExpression = copayFilterExpression.concat(`, ${squadExp}`);
    }
    if (siteExp !== '') {
      copayFilterExpression = copayFilterExpression.concat(`, ${siteExp}`);
    }
    if (productExp !== '') {
      copayFilterExpression = copayFilterExpression.concat(`, ${productExp}`);
    }
    setCopayExpressions(copayFilterExpression);
    return copayFilterExpression;
  };

  const [timeSpan, setTimeSpan] = useState();

  useEffect(() => {
    setTimeSpan(
      timeSpanOptions
        ?.filter((item) => item.Module === MODULE_NAME.CopayAnalytics)
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
  }, [timeSpanOptions]);

  const getCopayData = async () => {
    try {
      // Calculate offset - will be 0 when pageIndex is 1
      let offset = Math.max(0, (pageIndex - 1) * pageSize);

      let expression = buildExpression();
      // Build payload for API request
      let payload = {
        measure,
        dimension: copayDimenssion,
        expression,
        sortBy: selectedColumns?.includes(sortBy.column)
          ? sortBy.column
          : undefined,
        order: selectedColumns?.includes(sortBy.column)
          ? sortBy.order
          : undefined,
        offset,
        pageSize,
      };

      // Make API call
      const result = await getCopayAnalyticsData({ ...payload });
      return result;
    } catch (error) {
      console.log(error);
    }
  };

  const handleTableChange = (column, order, pagination) => {
    let currentPageSize = pagination.pageSize;

    // Reset page to 1 if page size changed
    if (pageSize !== currentPageSize) {
      setPageIndex(1);
      setPageSize(currentPageSize);
    } else {
      setPageIndex(pagination.current);
    }

    setSortBy({ column, order: SORT_BY[order] });
  };

  const onMenuOpen = useCallback((filterName, value) => {
    let menuIsOpenLocal = menuIsOpen;

    if (filterName !== '' && value) {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: filterName === key };
      }, {});
    } else if ((filterName !== '' && !value) || filterName === '') {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: false };
      }, {});
    }
    setMenuIsOpen({ ...menuIsOpenLocal });
  }, []);

  const downloadData = () => {
    dispatch(
      exportData(
        TABLE_NAME_COPAY_ANALYTICS,
        selectedCustomer?.value,
        copayExpressions,
        undefined,
        copayDimenssion,
        undefined,
        undefined,
        copayDimenssion,
        measure,
        selectedView === ACCOUNT_TYPE.site
          ? 'SiteCopayAnalytics'
          : 'AccountCopayAnalytics'
      )
    );
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    // Toggle selected columns
    const nextSelected = checked
      ? [...selectedColumns, value]
      : selectedColumns.filter((item) => item !== value);

    // Toggle copay dimensions
    let nextSelectedDimention = checked
      ? [...copayDimenssion, value]
      : copayDimenssion.filter((item) => item !== value);

    // Handle Site-specific logic
    if (value === 'Site') {
      if (checked) {
        nextSelectedDimention.push('Site_ID', 'site_zip');
      } else {
        nextSelectedDimention = nextSelectedDimention.filter(
          (item) => item !== 'Site_ID' && item !== 'site_zip'
        );
      }
    }

    // Ensure unique elements in the dimension array
    nextSelectedDimention = uniq(nextSelectedDimention);

    setSelectedColumns(nextSelected);
    setCopayDimension(nextSelectedDimention);
  };

  const handlePopoverVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  const columnSelectionPanel = (
    <Checkbox.Group
      defaultValue={selectedColumns}
      className={styles.checkboxGroup}
      key={Math.random()}>
      {COPAY_ANALYTICS_COLUMNS.map((column) => (
        <div
          className={styles.checkboxWrapper}
          key={column.id}>
          <ConfigProviderCheckbox>
            <Checkbox
              className={styles.checkbox}
              key={column.dataIndex}
              value={column.dataIndex}
              disabled={column.columnVisiblity === ColumnVisiblity?.Mandatory}
              onChange={handleCheckboxChange}>
              {column.title}
            </Checkbox>
          </ConfigProviderCheckbox>
        </div>
      ))}
    </Checkbox.Group>
  );

  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const CopayTooltip = (
    <Tooltip className='gne-tooltip'>
      <>
        Total Paid Claims are the total number of claims paid during selected
        time period. These claims include both drug and admin claims for those
        brands that have an admin program.
        <br />
        <br />
        New Enrollments are the new patients enrolled in a specific product's
        Copay program during selected time period.
        <br />
        <br />
        Total Enrollments is the sum of all enrollments (new + re-enrolled
        patients).
        <br />
        <br />
        Unique Utilizers (Patients) are the total number of patients who
        submitted at least one claim during the selected time period.
      </>
    </Tooltip>
  );

  const popoverContent = (
    <div className={styles.customPopup}>{columnSelectionPanel}</div>
  );

  const handleClick = async (rowData) => {
    const payload = {
      value: rowData?.Site_ID,
      label: rowData?.Site,
      zip: rowData?.zip,
      flag: FLAG.site[0],
    };
    dispatch(setSeletedView('site'));
    dispatch(setFilterInit());
    dispatch(setSelectedCustomer(payload));
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
    dispatch(setSelectedInsightView({}));
    dispatch(setAllInsightView([]));
    navigation(`/customerView/list/${rowData?.Site}`);
  };

  const resetFilters = () => {
    dispatch(setCopayAnalyticsFiltersInitialState());
  };

  const handleFilterChange = (value) => {
    setPageIndex(1);
  };

  return (
    <div id='CopayAnalytics'>
      <Row>
        <Col
          className='d-flex align-items-center'
          md={6}>
          <p className='title title__bold title__large mb-1'>Copay Analytics</p>
          <OverlayTrigger overlay={CopayTooltip}>
            <i className={`icon icon__info__gray m-2 `} />
          </OverlayTrigger>
        </Col>
        <Col
          className='d-flex justify-content-end align-items-center'
          md={6}>
          <Popover
            content={popoverContent}
            trigger='click'
            open={popoverVisible}
            onOpenChange={handlePopoverVisibleChange}>
            <i
              className={`icon icon__affiliations_standardTable_settings me-3`}
            />
          </Popover>
          <OverlayIcon
            tooltip={'Reset Filters'}
            onClick={resetFilters}
            className={`icon icon__reset-filters me-3`}
          />
          <OverlayTrigger overlay={exportTooltip}>
            <i
              onClick={downloadData}
              className={`icon icon__affiliations_export_excel1`}
            />
          </OverlayTrigger>
        </Col>
      </Row>
      <Row>
        <Col>
          <p
            className={`title title__x-small title__italic title__grey ${classes['co-verbiag']}`}>
            {timeSpan} | Provides directional understanding of Genentech Copay
            Program utilization by account. Select multiple quarters to
            aggregate the data. For a comparative view of quarters, use the gear
            icon and select quarter.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label className='title__x-small'>Ecosystem</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={copayAnalyticsFilters}
            appid={COPAY_ANALYTICS_APP_ID}
            fieldName='copayEcosystem'
            isMulti={BOOLEAN_TRUE}
            filterName={COPAY_ANALYTICS_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              selectedProduct,
              selectedSquad,
              selectedSite,
              selectedTimePeriod,
            ]}
            onChange={handleFilterChange}
          />
        </Col>

        <Col md={3}>
          <label className='title__x-small'>Site Name</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={copayAnalyticsFilters}
            appid={COPAY_ANALYTICS_APP_ID}
            fieldName='copaySiteAddressName'
            isMulti={true}
            filterName={COPAY_ANALYTICS_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              selectedProduct,
              selectedSquad,
              selectedTimePeriod,
              selectedEcosystem,
            ]}
            onChange={handleFilterChange}
          />
        </Col>

        <Col md={2}>
          <label className='title__x-small'>Time period</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={copayAnalyticsFilters}
            appid={COPAY_ANALYTICS_APP_ID}
            fieldName='copayQuarter'
            expression={copayFilterExpression}
            isMulti={true}
            filterName={COPAY_ANALYTICS_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              selectedProduct,
              selectedSquad,
              selectedSite,
              selectedEcosystem,
            ]}
            onChange={handleFilterChange}
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Product</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={copayAnalyticsFilters}
            appid={COPAY_ANALYTICS_APP_ID}
            fieldName='copayProduct'
            isMulti={true}
            filterName={COPAY_ANALYTICS_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              selectedSquad,
              selectedSite,
              selectedTimePeriod,
              selectedEcosystem,
            ]}
            onChange={handleFilterChange}
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Squad</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={copayAnalyticsFilters}
            fieldName='copaySquad'
            appid={COPAY_ANALYTICS_APP_ID}
            isMulti={true}
            filterName={COPAY_ANALYTICS_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              selectedProduct,
              selectedSite,
              selectedTimePeriod,
              selectedEcosystem,
            ]}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
      &nbsp;
      <Row>
        <Spin spinning={isLoading || isExporting}>
          <ConfigurableTable
            rows={copayData?.values}
            columns={getRestrictedColumn(
              TABLE_NAME_COPAY_ANALYTICS,
              filteredColumns,
              columnRestriction
            ).map((col) => {
              if (col.dataIndex === 'Site') {
                return {
                  ...col,
                  render: (text, record) => (
                    <span
                      className='span-link'
                      onClick={() => {
                        handleClick(record);
                      }}>
                      {text}
                    </span>
                  ),
                };
              }
              return col;
            })}
            expandRowByClick={true}
            enableColumnSelection={false}
            enableExport={false}
            tableName={TABLE_NAME_COPAY_ANALYTICS}
            expression={copayFilterExpression}
            isGlobalExport={true}
            pagination={pagination}
            isGlobalSort={true}
            onSort={handleTableChange}
            dimentions={{ x: 1100, y: 400 }}
          />
        </Spin>
      </Row>
    </div>
  );
};

export default CopayAnalytics;
